import api from './client';

// API Documentation
export const apiDocsAPI = {
  getEndpoints: () => api.get('/api-docs/endpoints'),
};
